/*
 * Sale split: devices without hover cannot fan the photo stack out by pointing at the panel, so the stack opens
 * once, when it scrolls into view. The motion itself is CSS (section-sale-split.css); this only adds `is-open`.
 * Pointer devices never use this path, and neither does anyone who asked for reduced motion (the stack is
 * already fanned for them).
 *
 * Being a custom element, it initializes again by itself whenever the section is inserted, which includes the
 * theme editor's `shopify:section:load` re-render.
 *
 * Everything lives inside the guard: every sale-split section on a page loads this file, and a second run must
 * not redeclare anything.
 */
if (!customElements.get('sale-split')) {
  // Share of the stack that must be visible before it opens.
  const VISIBLE_SHARE = 0.6;

  customElements.define(
    'sale-split',
    class SaleSplit extends HTMLElement {
      constructor() {
        super();
        this.observer = null;
        this.noHover = window.matchMedia('(hover: none)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      }

      connectedCallback() {
        if (!this.noHover.matches || this.reducedMotion.matches) return;

        const stack = this.querySelector('.sale-split__stack');
        if (!stack || !('IntersectionObserver' in window)) {
          if (stack) stack.classList.add('is-open');
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            stack.classList.add('is-open');
            this.disconnectObserver();
          },
          { threshold: VISIBLE_SHARE }
        );
        this.observer.observe(stack);
      }

      disconnectedCallback() {
        this.disconnectObserver();
      }

      disconnectObserver() {
        if (!this.observer) return;
        this.observer.disconnect();
        this.observer = null;
      }
    }
  );
}
